import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Partners from './components/Partners';
import Services from './components/Services';
import Telemedicine from './components/Telemedicine';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Practice from './components/Practice';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LegalPage from './components/LegalPage';
import BookingPage from './components/BookingPage';
import BookingConfirmation from './components/BookingConfirmation';
import AdminPage from './components/AdminPage';
import ManageBookingPage from './components/ManageBookingPage';

function HomePage() {
  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <About />
      <Partners />
      <Services />
      <Telemedicine />
      <Testimonials />
      <FAQ />
      <Practice />
      <Pricing />
      <Contact />
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/booking/confirmation/:bookingId" element={<BookingConfirmation />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/manage/:token" element={<ManageBookingPage />} />
      </Routes>
    </Router>
  );
}
